var Logger = require('./logger');
var logger = new Logger();
module.exports = logger;
